import React from 'react';
import { Box, Typography } from '@mui/material';
import { ComplianceProps } from '../../types/props';

export const Compliance: React.FC<ComplianceProps> = ({ fiscalSponsorId }) => {
  return (
    <Box>
      <Typography variant="h4">Compliance</Typography>
    </Box>
  );
}; 